import { ref, computed, watchEffect } from 'vue'
import { useLocalStorage, useMediaQuery } from '@vueuse/core'

const POSITION = {
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded',
  FLOATING: 'floating',
  HIDDEN: 'hidden'
}

const mode = useLocalStorage('nav-mode', POSITION.EXPANDED)
const position = ref(null)

const isMobileNav = useMediaQuery('(max-width: 640px)')

export function useNavigation() {
  watchEffect(() => {
    position.value = isMobileNav.value ? POSITION.HIDDEN : mode.value
  })

  const onToggleMode = () => {
    mode.value = mode.value === POSITION.COLLAPSED ? POSITION.EXPANDED : POSITION.COLLAPSED
  }

  const onMouseEnterNav = () => {
    if (position.value === POSITION.COLLAPSED) {
      position.value = POSITION.FLOATING
    }
  }

  const onMouseleaveNav = () => {
    if (position.value === POSITION.FLOATING) {
      position.value = POSITION.COLLAPSED
    }
  }

  const onMobileOpen = () => {
    position.value = POSITION.FLOATING
  }

  const onMobileClose = () => {
    position.value = POSITION.HIDDEN
  }

  const onClickOutsideNav = () => {
    if (isMobileNav.value) {
      onMobileClose()
    }
  }

  const isExpanded = computed(() => position.value === POSITION.EXPANDED)
  const isCollapsed = computed(() => position.value === POSITION.COLLAPSED)
  const isFloating = computed(() => position.value === POSITION.FLOATING)
  const isHidden = computed(() => position.value === POSITION.HIDDEN)

  const inCollapsedMode = computed(() => mode.value === POSITION.COLLAPSED)

  return {
    mode,
    position,

    onToggleMode,
    onMouseEnterNav,
    onMouseleaveNav,
    onMobileOpen,
    onMobileClose,
    onClickOutsideNav,

    isExpanded,
    isCollapsed,
    isFloating,
    isHidden,

    inCollapsedMode,

    isMobileNav
  }
}
